/* eslint-disable react-hooks/exhaustive-deps */
import PanelBoxLayout from 'components/layout/panelBox';

import { ReactSVG } from 'react-svg';
import { Divider } from 'antd';

import * as S from './styles';
import { Column } from '@ant-design/plots';
import PrimaryButton from 'components/form/buttons/primaryButton';
import Gap from 'components/gap';
import { useActions } from 'common/hooks/useActions';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { formatDuration } from 'common/helpers/format';

export default function DashboardCafeteria() {
  const { dashboardCafeteriaRequestAction } = useActions();
  const { cafeteria } = useTypedSelector((state: any) => state.Dashboard);

  useEffect(() => {
    dashboardCafeteriaRequestAction({});
  }, []);

  const config = {
    data: cafeteria?.data?.tea_room_order_chart
      ? cafeteria?.data?.tea_room_order_chart?.map((item: any) => ({
          ...item,
          totalcount: Number(item.totalcount),
          name: `${item.name}`
        }))
      : [],
    xField: 'name',
    yField: 'totalcount',
    style: {
      fill: '#1DBAAF',
      minWidth: 20,
      maxWidth: 20
    },
    axis: {
      y: { title: 'Total count' }
    },
    tooltip: {
      items: [{ field: 'totalcount' }, { field: 'avgresponsetime' }]
    },
    interaction: {
      tooltip: {
        render: (_event: any, { items }: any) => {
          return (
            <S.Tooltip>
              <S.TooltipGrid>
                <span>Number of Orders: </span>
                <span style={{ color: '#1DBAAF' }}>{items?.[0]?.value}</span>
              </S.TooltipGrid>
              <Gap size="8px" />
              <S.TooltipGrid>
                <span>Average Delivery Time: </span>
                <span style={{ color: '#1DBAAF' }}>{formatDuration(Number(items?.[1]?.value))}</span>
              </S.TooltipGrid>
            </S.Tooltip>
          );
        }
      }
    }
  };

  return (
    <S.Container>
      <PanelBoxLayout
        title="Cafeteria"
        afterTitle={
          <S.Div style={{ display: 'flex', gap: 8, marginLeft: 6 }}>
            <ReactSVG src="/icons/star-o-2.svg" />
            <S.Span>{cafeteria?.data?.service_rate_average}</S.Span>
          </S.Div>
        }
        info={
          <S.Info>
            <ReactSVG
              src="/icons/fill/timer.svg"
              beforeInjection={(svg) => {
                svg.setAttribute('fill', `#2B3674`);
              }}
            />
            <S.Text>Average Delivery Time:</S.Text>
            <S.Span>{formatDuration(cafeteria.data?.delivered_response_average)}</S.Span>
          </S.Info>
        }
      >
        <Divider style={{ margin: '20px 0' }} />
        <Column {...config} height={380} key={cafeteria?.data?.tea_room_order_chart?.length} />
        <Gap size="20px" />
        <Link to={'/panel/cafeteria/statistics'}>
          <PrimaryButton style={{ margin: 'auto' }}>
            Number of Order Per Items
            <ReactSVG
              src="/icons/fill/arrow-right.svg"
              beforeInjection={(svg) => {
                svg.setAttribute('fill', `#fff`);
              }}
            />
          </PrimaryButton>
        </Link>
      </PanelBoxLayout>
    </S.Container>
  );
}
